import { useMutation } from "@tanstack/react-query";
import { UpdateUserOperationRequest } from "@/Stub/V1";
import { UsersApiClient } from "@/Service/Api/V1/ApiClients/UsersApiClient";
import { processValidationErrors } from "@/Util/Api/processValidationErrors";

export const useUpdateUser = () => useMutation({
    mutationFn: async (data: UpdateUserOperationRequest) => {
        try {
            return await UsersApiClient.updateUser(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});
